import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import FacetedSearchCompact from '../Components/FacetedSearchCompact'
import {
    query,
    submitSearchFacet,
    toggleVisibleGroup,
    searchFacetChange,
} from '../Actions/FacetedSearch.action'
import SubNav from '../Components/SubNavCompact'
import SortCriteriaCompact from '../Components/SortCriteriaCompact'
import FilterTag from '../Components/FilterTags'
import { translate } from '../Services/translation'
import {
    PRODUCT_VIEW_CACHED,
    updateFilterOption,
} from '../Actions/FacetedSearch.action'

class FacetedSearchCompactContainer extends Component {
    constructor(props) {
        super(props)
        const { facetFilters } = props
        const contentOpen = ''
        const selectedSortingValue = ''

        this.state = {
            facetFilters,
            contentOpen,
            selectedSortingValue,
        }

        this.onSortingChange = this.onSortingChange.bind(this)
    }

    componentDidMount() {
        this.props.query(window.location.search.substr(1) || '', false)
    }

    onFacetChange(filter, option) {
        this.setState((prevState, props) => {
            const { facetFilters } = this.state
            const newFilters = updateFilterOption(facetFilters, filter, option)
            return {
                ...prevState,
                facetFilters: newFilters,
            }
        })
    }

    setOpenedSectionContent(section) {
        this.setState((prevState) => ({
            ...prevState,
            contentOpen: section,
        }))
    }

    onSortingChange(selectedSortingValue) {
        this.setState((prevState) => ({
            ...prevState,
            selectedSortingValue: selectedSortingValue,
        }))
    }

    onSortingClose(sortCriterias) {
        if (
            this.state.selectedSortingValue &&
            this.state.selectedSortingValue != ''
        ) {
            var selectedSortingOption = [
                ...sortCriterias.filter((sort) => sort.selected === true),
                {},
            ][0]
            if (
                !selectedSortingOption ||
                selectedSortingOption.value != this.state.selectedSortingValue
            ) {
                window.location = this.state.selectedSortingValue
            }
        }
    }

    static getDerivedStateFromProps(nextProp, prevState) {
        if (nextProp.productsViewCachedId !== prevState.productsViewCachedId) {
            return {
                ...prevState,
                ...nextProp,
            }
        }
        return prevState
    }

    onSearchResultDataChange(dom) {
        if ([null, undefined].includes(dom)) {
            return
        }
        const container = document.createElement('div')
        container.innerHTML = dom
        const existingResult = document.querySelector('#search-result')
        const tempResult = container.querySelector('#search-result')
        const existingFilter = existingResult.querySelector(
            '#facetedSearchCompact'
        )
        const tempFilter = tempResult.querySelector('#facetedSearchCompact')
        const replace = (node, newNode) =>
            node.parentNode.replaceChild(newNode, node)
        // move existingFilter from existingResult to tempResult
        replace(tempFilter, existingFilter)
        // replace existingResult with tempResult ( newResult )
        replace(existingResult, tempResult)
        // bootstrap react components if any exists in the search result
        window.__litium.bootstrapComponents()
    }

    componentDidUpdate() {
        const productViewCached = window.__litium.cache
            ? window.__litium.cache[PRODUCT_VIEW_CACHED] || {}
            : {}
        if (!productViewCached.used) {
            productViewCached.used = true
            const dom = productViewCached.productsView
            dom && this.onSearchResultDataChange(dom)
        }
    }

    render() {
        const {
            subNavigation,
            sortCriteria,
            navigationTheme = '',
            ...facetProps
        } = this.props
        const { facetFilters } = this.state
        const facetState = {
            ...facetProps,
            facetFilters,
            onFacetChange: (filter, option) =>
                this.onFacetChange(filter, option),
        }
        const empty = (array) => !(array && array.length)
        const subNavigations = !subNavigation ? null : [subNavigation]
        const sortCriterias =
            !sortCriteria || !sortCriteria.sortItems
                ? null
                : sortCriteria.sortItems
        const hidden = [
            subNavigations,
            facetFilters,
            sortCriterias,
        ].every((arr) => empty(arr))
        return hidden ? null : (
            <Fragment>
                <div className="compact-filter hide-for-large">
                    {!empty(facetFilters) && (
                        <Fragment>
                            <div className="compact-filter__section-button">
                                <button
                                    onClick={() =>
                                        this.setOpenedSectionContent('filters')
                                    }
                                >
                                    {translate('facet.header.filter')}
                                </button>
                            </div>
                            {this.state.contentOpen == 'filters' && (
                                <div className="compact-filter__section-content">
                                    <div className="compact-filter__section-content--header">
                                        {translate('facet.header.filter')}
                                        <span
                                            onClick={() => {
                                                this.setOpenedSectionContent('')
                                                facetState.toggleVisibleGroup({
                                                    id:
                                                        facetState
                                                            .visibleDropdownMenu[0],
                                                })
                                                facetState.onSubmit(
                                                    facetFilters
                                                )
                                            }}
                                            className="icon-close"
                                        ></span>
                                    </div>
                                    <FacetedSearchCompact {...facetState} />
                                </div>
                            )}
                        </Fragment>
                    )}
                    {!empty(sortCriterias) && (
                        <Fragment>
                            <div className="compact-filter__section-button">
                                <button
                                    onClick={() =>
                                        this.setOpenedSectionContent(
                                            'sortCriteria'
                                        )
                                    }
                                >
                                    {translate('facet.header.sortCriteria')}
                                </button>
                            </div>
                            {this.state.contentOpen == 'sortCriteria' && (
                                <div className="compact-filter__section-content">
                                    <div className="compact-filter__section-content--header">
                                        {translate('facet.header.sortCriteria')}
                                        <span
                                            onClick={() => {
                                                this.setOpenedSectionContent('')
                                                this.onSortingClose(
                                                    sortCriterias
                                                )
                                            }}
                                            className="icon-close"
                                        ></span>
                                    </div>
                                    <SortCriteriaCompact
                                        {...{ sortCriteria: sortCriterias }}
                                        selectedSortingValue={
                                            this.state.selectedSortingValue
                                        }
                                        onSortingChange={this.onSortingChange}
                                    />
                                </div>
                            )}
                        </Fragment>
                    )}
                </div>
                {navigationTheme === 'category' && (
                    <div className="compact-filter category-theme show-for-large">
                        <FacetedSearchCompact {...facetState} />
                    </div>
                )}
                <FilterTag {...{ ...facetProps, navigationTheme }} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({
    facetedSearch: {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
    },
}) => {
    return {
        subNavigation,
        sortCriteria,
        facetFilters,
        visibleDropdownMenu,
        navigationTheme,
        productsViewCachedId,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        query: (q, withHtmlResult) => dispatch(query(q, withHtmlResult)),
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
        toggleVisibleGroup: (group) => dispatch(toggleVisibleGroup(group)),
        searchFacetChange: (group, item) =>
            dispatch(searchFacetChange(group, item)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacetedSearchCompactContainer)
